export default __webpack_public_path__ + "static/km-7bbcd6dcf8a82d19374d6d3a960cbcac.svg";